import { render, staticRenderFns } from "./modalConsulta.vue?vue&type=template&id=48cbe282&"
import script from "./modalConsulta.vue?vue&type=script&lang=js&"
export * from "./modalConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports